import useAxiosApi from '../../hooks/useAxiosApi';
import { useState } from 'react';
import styles from './CustomText.module.scss';
import { FaArrowRight } from 'react-icons/fa';
import { ICON_SIZE16, MOVINGREQUEST_URL } from '../../constants';
import ToDoModal from '../modal/Mission/ToDoModal';
import toast from "react-hot-toast";

const moment = require('moment-timezone');

const CustomSplitText = ({ data, isLoading, setIsLoading, setRefresh }) => {
  const axiosApi = useAxiosApi();

  const [dataDetails, setDataDetails] = useState(null)
  const [modalVisible, setModalVisible] = useState(false);

  const getMoveRequestDetails = async (id) => {
    setIsLoading(true);
    const toastLoading = toast.loading('Chargement en cours...');
    await axiosApi.post(`${MOVINGREQUEST_URL}/details`,
      {
        id
      })
      .then((result) => {
        setDataDetails(result.data.list);
        setModalVisible(true);
        toast.remove(toastLoading);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error('Une erreur est survenue', { id: toastLoading });
        setIsLoading(false);
      });
  }

  return (
    <>
      <div className={styles.Wrapper} onClick={async () => {
        await getMoveRequestDetails(data.id)
      }}>
        <label className={styles.TextBold}>{data.num_remorque}</label>
        <div className={styles.WrapperRow}>
          <label className={styles.TextLeft}>{data.code_batiment_actuel}-{data.emplacement_actuel} {<FaArrowRight
            size={ICON_SIZE16}
            className={styles.ArrowIcon}/>} {data.code_batiment_demande}-{data.emplacement_demande}</label>
          <label
            className={styles.TextRight}>{moment(data.date_demande.substring(0, 16)).format('DD/MM/YYYY HH:mm')}h</label>
        </div>
      </div>
      <ToDoModal
        data={dataDetails}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        setRefresh={setRefresh}
      />
    </>
  )
}

export default CustomSplitText;